import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";
import { useEffect, useContext } from "react";
import { FORM } from "helpers/validations";
import { ProductContext } from "lib/productContext";
import Input from "components/shared/input/Input";
import Presets from "./presets/Presets";

import {
    Label,
    ValueInputStyled,
    Info,
    Text,
    InputContainer
} from "./Value.styled";

function ValueInput({ id }) {
    const name = id ? `${id}.value` : "value";
    const skuName = id ? `${id}.sku` : "sku";
    const minimumValue = 5;
    const maximumValue = 150;
    const { setValue, watch, register, unregister, errors } = useFormContext();

    const { productData, productLoading, productError } = useContext(
        ProductContext
    );

    const inputValue = watch(name);

    useEffect(() => {
        register({ name: skuName });
        return () => {
            unregister({ name: skuName });
        };
    }, [register, unregister, skuName]);

    useEffect(() => {
        if (
            inputValue &&
            !productLoading &&
            !productError &&
            productData?.product?.variants?.edges
        ) {
            const variant = productData.product.variants.edges.find(
                item => Number(item.price) === Number(inputValue)
            );

            if (variant?.sku) {
                setValue(skuName, variant.sku, { shouldDirty: true });
            }
        }
    }, [
        inputValue,
        productData,
        productLoading,
        productError,
        setValue,
        skuName
    ]);

    return (
        <ValueInputStyled>
            <Info>
                <Label>Bedrag:</Label>
                <Text>{`min. €${minimumValue},- max. €${maximumValue},- `}</Text>
            </Info>
            <Presets name={name} />
            <InputContainer>
                <Input
                    leftIconTop={50}
                    leftIcon={inputValue && <span>€</span>}
                    name={name}
                    inputMode="numeric"
                    type="number"
                    aria-label="waarde invoerveld"
                    placeholder="Of vul zelf een bedrag in.."
                    errorMessage={errors?.[name]?.message}
                    min={minimumValue}
                    max={maximumValue}
                    ref={register(FORM.VALUE)}
                />
            </InputContainer>
        </ValueInputStyled>
    );
}
ValueInput.defaultProps = {
    id: undefined
};
ValueInput.propTypes = { id: PropTypes.string };

export default ValueInput;
